import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useTheme } from '@material-ui/core/styles'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  CircularProgress,
} from '@material-ui/core'

import { CloseRounded as CloseIcon } from '@material-ui/icons'

import { changeDisplayName } from '../../../redux/conversations/actions'

import api from '../../../services/api'
import IconButton from '../../atoms/inputs/iconButton'
import TextField from '../../atoms/inputs/textfield'

const EditName = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const theme = useTheme()
  const [originalName, setOriginalName] = useState()
  const [firstName, setFirstName] = useState()
  const [lastName, setLastName] = useState()
  const [updateLoading, setUpdateLoading] = useState(false)
  const [cleanLoading, setCleanLoading] = useState(false)
  const [form, setForm] = useState([])
  const [formError, setFormError] = useState([])

  const undock = useSelector((state) => state.undock)

  // const activeConversation = undock.data
  //   ? undock.activeConversation
  //   : useSelector((state) => state.activeConversation)

  // const conversations = undock.data
  //   ? undock.conversations
  //   : useSelector((state) => state.conversations)

  // const conversation = conversations && conversations[activeConversation]

  const activeConversation = useSelector((state) => state.activeConversation)
  const conversations = useSelector(
    (state) => state.conversations.conversations
  )
  const conversation = useSelector(
    (state) => state.conversations.conversations[activeConversation]
  )

  useEffect(() => {
    const name = conversation?.consumer?.displayName
      ? conversation?.consumer?.displayName
      : conversation?.consumer?.name
    setOriginalName(conversation?.consumer?.name)
    setFirstName(name?.split(' ')[0])
    setLastName(name?.split(' ')[1])
    setForm({ contactName: name })
  }, [conversation])

  const inputHandle = (event) => {
    setForm((form) => ({
      ...form,
      [event?.target?.name]: event?.target?.value,
    }))
  }

  const updateHandle = () => {
    if (conversation?.conversationId && form.contactName !== originalName) {
      setUpdateLoading(true)
      api({
        method: 'patch',
        url: `/display-name?id=${conversation?.consumer.id}`,
        data: {
          display_name: form.contactName,
        },
      })
        .then((response) => {
          setUpdateLoading(false)
          if (response.status !== 200) {
          } else {
            dispatch(
              changeDisplayName({
                conversationId: conversation?.conversationId,
                displayName: form.contactName,
              })
            )
            props.setDialogOpen(false)
          }
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }

  const cleanHandle = () => {
    if (conversation?.conversationId) {
      setCleanLoading(true)
      api({
        method: 'patch',
        url: `/display-name?id=${conversation?.consumer.id}`,
        data: {
          display_name: null,
        },
      })
        .then((response) => {
          setCleanLoading(false)
          if (response.status !== 200) {
          } else {
            dispatch(
              changeDisplayName({
                conversationId: conversation?.conversationId,
                displayName: null,
              })
            )
          }
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }

  const renderCleanButton = () => {
    if (conversation?.consumer?.displayName) {
      return (
        <Button
          size="large"
          color="secondary"
          onClick={(e) => {
            e.stopPropagation()
            cleanHandle()
          }}
          disabled={updateLoading || cleanLoading}
        >
          {cleanLoading ? (
            <CircularProgress size={25} color="secondary" />
          ) : (
            t('buttons.clean')
          )}
        </Button>
      )
    }
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="xs"
        open={props.dialogOpen}
        onClick={(e) => {
          e.stopPropagation()
        }}
        onClose={(e) => {
          e.stopPropagation()
          props.setDialogOpen(false)
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>{t('commons.editName')}</div>
            <div>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation()
                  props.setDialogOpen(false)
                }}
                style={{ color: theme.palette.primary.main }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <TextField
            id="field-contactName"
            label={t('fields.contactName.label')}
            placeholder={t('fields.contactName.placeHolder')}
            type="text"
            color="primary"
            variant="outlined"
            name="contactName"
            value={form.contactName ? form.contactName : ''}
            onChange={inputHandle}
            error={formError?.contactName ? true : false}
            helperText={
              formError?.contactName &&
              t(`fields.contactName.errors.${formError.contactName}`)
            }
            shrink={true}
            fullWidth={true}
          />
        </DialogContent>
        <DialogActions>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
            }}
          >
            <div>{renderCleanButton()}</div>
            <div>
              <Button
                size="large"
                color="primary"
                onClick={(e) => {
                  e.stopPropagation()
                  props.setDialogOpen(false)
                }}
              >
                {t('buttons.cancel')}
              </Button>
              <Button
                size="large"
                variant="contained"
                color="primary"
                disabled={updateLoading || cleanLoading}
                onClick={(e) => {
                  e.stopPropagation()
                  updateHandle()
                }}
                style={{ marginLeft: 5 }}
              >
                {updateLoading ? (
                  <CircularProgress size={25} color="primary" />
                ) : (
                  t('buttons.confirm')
                )}
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default EditName
